import { useEffect, useState } from 'react';
import { Cardio } from './pages/Cardio';
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/Login';
import { ManageExercises } from './pages/manage/Exercises';
import { ManageDays } from './pages/manage/Days';
import { ManageMuscles } from './pages/manage/Muscles';
import { ManageDiagram } from './pages/manage/Diagram';
import { useRoute } from './lib/router';

type AuthState = 'checking' | 'in' | 'out';

export function App() {
  const [auth, setAuth] = useState<AuthState>('checking');
  const path = useRoute();

  useEffect(() => {
    fetch('/api/auth/me')
      .then((r) => setAuth(r.ok ? 'in' : 'out'))
      .catch(() => setAuth('out'));
  }, []);

  if (auth === 'checking') {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#666',
        }}
      >
        …
      </div>
    );
  }
  if (auth === 'out') return <Login onSuccess={() => setAuth('in')} />;

  if (path.startsWith('/cardio')) return <Cardio />;
  if (path.startsWith('/manage/exercises')) return <ManageExercises />;
  if (path.startsWith('/manage/days')) return <ManageDays />;
  if (path.startsWith('/manage/muscles')) return <ManageMuscles />;
  // Diagram verifier is still reachable at /manage/diagram but no longer in
  // the main nav — it's an internal tool used when re-running the muscle map.
  if (path.startsWith('/manage/diagram')) return <ManageDiagram />;
  return <Dashboard />;
}
